import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FavoriteModal, FavoriteRow, FavoriteShimmer, FavoritesNoSportModal } from "src/components";
import { ProfileData, ProfileDataAction } from "src/store";

export const ProfileFavorites: React.FC = () => {

    //#region Dependencies

    const dispatch = useDispatch();
    const user: ProfileData = useSelector((state: any) => state.ProfileDataState);

    //#endregion

    //#region properties

    const favorites = user.favorites;

    //#endregion

    //#region mehtods


    const fetchData = () => dispatch(ProfileDataAction.getFavorites(true));

    //#endregion

    //#region effects

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //#endregion

    return (
        <div className="no-package py-2 px-md-2">
            {
                favorites.loading && !favorites.list.length &&
                <FavoriteShimmer />
            }
            {favorites.list.map((x, index) => <FavoriteRow key={index} {...x} />)}
            <FavoriteModal />
            <FavoritesNoSportModal />
        </div>
    );
};